<template>
	<div>
		<div v-if="xml">
			<viewXml :project="project" ref="view_xml"></viewXml>
		</div>
		<div v-show="docx">
			<div :id="'docx-' + id"></div>
			<b-button variant="link" @click="dowload">Télécharger</b-button>
		</div>
		<div v-if="html">
			<p v-if="showFileName">{{ name_file }}</p>
			<iframe height="500px" width="100%" :srcdoc="html" id="preview" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>
			<b-button v-if="showDownload" variant="link" @click="dowload">Télécharger</b-button>
		</div>
		<div v-if="pdf_buffer">
			<p v-if="showFileName">{{ name_file }}</p>
			<div>
				<span @click="currentPage--" v-if="currentPage > 1">&lt; </span
				>{{ currentPage }} / {{ pageCount }} page<span v-if="pageCount > 1">s</span>
				<span @click="currentPage++" v-if="currentPage < pageCount">
					&gt;</span
				>
			</div>
			<!-- <pdf
				style="border: solid"
				:page="currentPage"
				@num-pages="pageCount = $event"
				v-bind:src="pdf_buffer" /> -->
			 <vue-pdf-embed 
			 	class="vue-pdf-embed"
				:ref="'pdf' + id"
				:page="currentPage"
				@rendered="handleDocumentRender"
				:source="pdf_buffer"
				:showAllPages="false" />
			<b-button v-if="showDownload" variant="link" @click="dowload">Télécharger</b-button>
		</div>
		<div v-if="image">
			<p v-if="showFileName">{{ name_file }}</p>
			<img style="max-height:100%; max-width:100%;" :src="image" />
		</div>
	</div>
</template>

<script>
	import pdf from "vue-pdf";
	import viewXml from "./viewXml.vue";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import { renderAsync, defaultOptions } from 'docx-preview'
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

	import treatments from "../services/treatments.js";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import utils from "../services/utils.js";
	import document_service from "../services/document.js";

	export default {
		name: "view_file_simplify",
		components: {
			pdf,
			viewXml,
			VuePdfEmbed
		},
		props: {
			uid_element: {
				default: null
			},
			project: {
				default: () => {},
			},
			showFileName: {
				type: Boolean,
				default: true,
				required: false,
			},
			data: {
				default: () => null,
			},
			name: {
				default: () => null,
			},
			details: {
				default: () => null,
			},
			file: {
				default: () => null,
			},
			showDownload: {
				type: Boolean,
				default: true,
				required: false,
			},
			getDownload: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				id: uniqueId(""),
				data_file: null,
				pdf_buffer: null,
				tabulator: null,
				tabulator_data: null,
				xml: null,
				editor: null,
				currentPage: 1,
				pageCount: 0,
				name_file: "",
				html: false,
				image: null,
				docx: false
			};
		},
		watch: {
			data: {
				deep: true,
				handler: async function () {
					console.log("viewfile data modif")
					if (this.data)
						this.viewFile(this.data, this.name, this.details, this.file)
				}
			}
		},
		methods: {
			handleDocumentRender () {
				console.log(this.$refs)
				this.pageCount = this.$refs['pdf' + this.id].pageCount
			},
			async dowload() {
				if (typeof this.data_file == "string")
					await treatments.getFileAlyx(
						this.data_file,
						true,
						"arraybuffer",
						this.name_file
					);
				else
					await treatments.getFile(
						this.data_file.item.id,
						this.data_file.item.name,
						true,
						"arraybuffer"
					);
				this.$emit("download");
			},
			viewFile: async function (data, name, details, file) {
				var self = this;
				this.pdf_buffer = "";
				this.tabulator_data = null;
				this.xml = null;
				this.html = null;
				this.image = null;

				if (!name && data)
					name = data.substring(data.lastIndexOf('/') + 1);

				this.data_file = data;
				this.name_file = name;

				console.log(data)
				console.log(name)

				if (name.endsWith(".xml") && details) {
					this.xml = true;
					this.$nextTick(async () => {
						this.$refs.view_xml.viewFile(data, name, details, file);
					});
				} else if (name.endsWith(".docx")) {
					this.docx = true;
					var element = document.getElementById(
						'docx-' + self.id
					);

					if (typeof data == "string")
						var results_file = await treatments.getFileAlyx(
							data,
							false,
							"arraybuffer"
						);
					else
						var results_file = await treatments.getFile(
							data.item.id,
							data.item.name,
							false,
							"arraybuffer"
						);
					
					results_file = new Blob([results_file]);

					renderAsync(results_file, element).then(x => {});
				} else if (name.endsWith(".pdf")) {
					if (typeof data == "string")
						var results_file = await treatments.getFileAlyx(
							data,
							false,
							"arraybuffer"
						);
					else
						var results_file = await treatments.getFile(
							data.item.id,
							data.item.name,
							false,
							"arraybuffer"
						);
					this.pdf_buffer = new Uint8Array(results_file);
				} else if (name.endsWith(".html") || name.endsWith(".txt")) {
					if (typeof data == "string")
						var results_file = await treatments.getFileAlyx(
							data,
							false,
							"text"
						);
					else
						var results_file = await treatments.getFile(
							data.item.id,
							data.item.name,
							false,
							"text"
						);
					this.html = results_file;
				}
				else if (name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".jpg"))
				{
					if (typeof data == "string")
						var results_file = await treatments.getFileAlyx(
							data,
							false,
							"arraybuffer"
						);
					else
						var results_file = await treatments.getFile(
							data.item.id,
							data.item.name,
							false,
							"arraybuffer"
						);
					this.image = `data:image/${name.split(".").pop()};base64,${Buffer.from(results_file, 'binary').toString('base64')}`;
				}
				else if (this.getDownload)
				{
					this.dowload();
				}
			},
		},
		async mounted() {
			if (this.uid_element)
			{
				var document = await document_service.getInfoFile(this.uid_element);
				this.viewFile(document.url, document.libelle)
				console.log(document)
			}
			if (this.data)
				this.viewFile(this.data, this.name, this.details, this.file)
		}
	};
</script>

<style>
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
</style>